import {isSelectiveAiDomains} from 'common/HelperFunctions'
import {Shield} from 'lucide-react'
import React from 'react'
import {useIntl} from 'react-intl'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from 'setup'

/**
 * White-label tenants set `powered_by_text` and must not see our name anywhere, so the widget
 * defers to it exactly like the portal footer does. Only tenants without it fall back to the
 * generic "Powered by AI".
 */
const ChatbotPoweredBy: React.FC = () => {
  const intl = useIntl()
  const isAiSelectiveDomain = isSelectiveAiDomains()
  const generalSettings = useSelector<RootState>(
    ({mainReducer}) => mainReducer.generalSettings,
    shallowEqual
  ) as any

  const tenantPoweredByText =
    typeof generalSettings?.powered_by_text === 'string'
      ? isAiSelectiveDomain
        ? generalSettings.powered_by_text.replace(/ilmversity/gi, 'Da1Timetable')
        : generalSettings.powered_by_text
      : generalSettings?.powered_by_text

  return (
    <div className='chatbot-powered-by'>
      <div className='chatbot-powered-by__brand'>
        <Shield size={12} className='chatbot-powered-by__icon' aria-hidden='true' />
        {tenantPoweredByText ? (
          <span
            className='chatbot-powered-by__tenant'
            dangerouslySetInnerHTML={{__html: tenantPoweredByText}}
          />
        ) : (
          <span>{intl.formatMessage({id: 'CHATBOT.POWERED_BY'})}</span>
        )}
      </div>
      <span className='chatbot-powered-by__disclaimer'>
        {intl.formatMessage({id: 'CHATBOT.AI_DISCLAIMER'})}
      </span>
    </div>
  )
}

export default ChatbotPoweredBy
